import React, {useEffect, useRef, useState} from "react";

import "./InternationalMap.css";
import { ReactComponent as WorldMap } from "./worldUltra.svg";
import ExtractCountryCenters from "./ExtractCountryCenters";


interface CountryMarker {
    name: string;
    coordinates: [number, number];
}

// const countries: CountryMarker[] = [
//     { name: "Angola", coordinates: [17.8739, -11.2027] },
//     { name: "Australia", coordinates: [134, -25] },
//     { name: "Austria", coordinates: [14.5501, 47.5162] },
//     { name: "Bahrain", coordinates: [50.5577, 26.0667] },
//     { name: "Barbados", coordinates: [-59.5432, 13.1939] },
//     { name: "Belgium", coordinates: [4.4699, 50.5039] },
//     { name: "Bermuda", coordinates: [-64.7505, 32.3078] },
//     { name: "Botswana", coordinates: [24.6849, -22.3285] },
//     { name: "Brazil", coordinates: [-51.9253, -14.235] },
//     { name: "British Virgin Is.", coordinates: [-64.6399, 18.4207] },
//     { name: "Burundi", coordinates: [29.9189, -3.3731] },
//     { name: "Cambodia", coordinates: [104.991, 12.5657] },
//     { name: "Cameroon", coordinates: [12.3547, 7.3697] },
//     { name: "Canada", coordinates: [-106.3468, 56.1304] },
//     { name: "Guernsey", coordinates: [-2.1313, 49.2144] },
//     { name: "China", coordinates: [104.1954, 35.8617] },
//     { name: "Costa Rica", coordinates: [-83.7534, 9.7489] },
//     { name: "Cyprus", coordinates: [33.4299, 35.1264] },
//     { name: "Czechia", coordinates: [15.473, 49.8175] },
//     { name: "Denmark", coordinates: [9.5018, 56.2639] },
//     { name: "Estonia", coordinates: [25.0136, 58.5953] },
//     { name: "Falkland Is.", coordinates: [-59.5236, -51.7963] },
//     { name: "Finland", coordinates: [25.7482, 61.9241] },
//     { name: "France", coordinates: [2.2137, 46.2276] },
//     { name: "Germany", coordinates: [10.4515, 51.1657] },
//     { name: "Ghana", coordinates: [-1.0232, 7.9465] },
//     { name: "Cayman Is.", coordinates: [-81.2546, 19.3133] },
//     { name: "Greece", coordinates: [21.8243, 39.0742] },
//     { name: "Hong Kong", coordinates: [114.1694, 22.3193] },
//     { name: "Hungary", coordinates: [19.5033, 47.1625] },
//     { name: "Iceland", coordinates: [-19.0208, 64.9631] },
//     { name: "India", coordinates: [78.9629, 20.5937] },
//     { name: "Indonesia", coordinates: [113.9213, -0.7893] },
//     { name: "Ireland", coordinates: [-8.2439, 53.4129] },
//     { name: "Israel", coordinates: [34.8516, 31.0461] },
//     { name: "Italy", coordinates: [12.5674, 41.8719] },
//     { name: "Jamaica", coordinates: [-77.2975, 18.1096] },
//     { name: "Japan", coordinates: [138.2529, 36.2048] },
//     { name: "Jordan", coordinates: [36.2384, 30.5852] },
//     { name: "Kazakhstan", coordinates: [66.9237, 48.0196] },
//     { name: "Laos", coordinates: [102.4955, 19.8563] },
//     { name: "Lebanon", coordinates: [35.8623, 33.8547] },
//     { name: "Lithuania", coordinates: [23.8813, 55.1694] },
//     { name: "Luxembourg", coordinates: [6.1296, 49.8153] },
//     { name: "Malawi", coordinates: [34.3015, -13.2543] },
//     { name: "Malaysia", coordinates: [101.9758, 4.2105] },
//     { name: "Malta", coordinates: [14.3754, 35.9375] },
//     { name: "Mauritius", coordinates: [57.5522, -20.3484] },
//     { name: "Mexico", coordinates: [-102.5528, 23.6345] },
//     { name: "Mozambique", coordinates: [35.5296, -18.6657] },
//     { name: "Namibia", coordinates: [18.4904, -22.9576] },
//     { name: "Nepal", coordinates: [84.124, 28.3949] },
//     { name: "Netherlands", coordinates: [5.2913, 52.1326] },
//     { name: "New Caledonia", coordinates: [165.618, -20.9043] },
//     { name: "New Zealand", coordinates: [174.886, -40.9006] },
//     { name: "Nigeria", coordinates: [8.6753, 9.082] },
//     { name: "Norway", coordinates: [8.4689, 60.472] },
//     { name: "Pakistan", coordinates: [69.3451, 30.3753] },
//     { name: "Peru", coordinates: [-75.0152, -9.19] },
//     { name: "Philippines", coordinates: [121.774, 12.8797] },
//     { name: "Poland", coordinates: [19.1451, 51.9194] },
//     { name: "Portugal", coordinates: [-8.2245, 39.3999] },
//     { name: "Congo", coordinates: [15.8277, -0.228] },
//     { name: "Réunion", coordinates: [55.5364, -21.1151] },
//     { name: "Russia", coordinates: [105.3188, 61.524] },
//     { name: "Rwanda", coordinates: [29.8739, -1.9403] },
//     { name: "United Kingdom", coordinates: [-4.2026, 56.4907] },
//     { name: "Senegal", coordinates: [-14.4524, 14.4974] },
//     { name: "Serbia", coordinates: [21.0059, 44.0165] },
//     { name: "Singapore", coordinates: [103.8198, 1.3521] },
//     { name: "Slovakia", coordinates: [19.699, 48.669] },
//     { name: "South Africa", coordinates: [24, -29] },
//     { name: "South Korea", coordinates: [127.7669, 35.9078] },
//     { name: "Spain", coordinates: [-3.7492, 40.4637] },
//     { name: "Qatar", coordinates: [51.1839, 25.3548] },
//     { name: "eSwatini", coordinates: [31.4659, -26.5225] },
//     { name: "Sweden", coordinates: [18.6435, 60.1282] },
//     { name: "Switzerland", coordinates: [8.2275, 46.8182] },
//     { name: "Taiwan", coordinates: [120.9605, 23.6978] },
//     { name: "Tanzania", coordinates: [34.8888, -6.369] },
//     { name: "Thailand", coordinates: [100.9925, 15.87] },
//     { name: "Turkey", coordinates: [35.2433, 38.9637] },
//     { name: "Uganda", coordinates: [32.2903, 1.3733] },
//     { name: "Ukraine", coordinates: [31.1656, 48.3794] },
//     { name: "United Arab Emirates", coordinates: [53.8478, 23.4241] },
//     { name: "United Kingdom", coordinates: [-3.436, 55.3781] },
//     { name: "United States of America", coordinates: [-98.5795, 39.8283] },
//     { name: "Uruguay", coordinates: [-55.7658, -32.5228] },
//     { name: "Uzbekistan", coordinates: [64.5853, 41.3775] },
//     { name: "Vietnam", coordinates: [108.2772, 14.0583] },
//     { name: "Zambia", coordinates: [27.8493, -13.1339] },
//     { name: "Zimbabwe", coordinates: [29.1549, -19.0154] },
// ];

// const countries: CountryMarker[] = [
//     { name: "Angola", coordinates: [748.43, 488.99] }, //fixed
//     { name: "Australia", coordinates: [1064.71, 525.33] }, //fixed
//     { name: "Austria", coordinates: [737.08, 300.47] }, //fixed
//     { name: "Bahrain", coordinates: [834.74, 367.48] }, //fixed
//     { name: "Barbados", coordinates: [538.91, 408.93] }, //fixed
//     { name: "Belgium", coordinates: [712.09, 290.25] }, //fixed
//     { name: "Bermuda", coordinates: [533.23, 348.74] }, //fixed
//     { name: "Botswana", coordinates: [766.04, 517.95] }, //fixed
//     { name: "Brazil", coordinates: [574.68, 488.99] }, //fixed
//     { name: "British Virgin Islands", coordinates: [527.55, 391.9] }, //fixed
//     { name: "Burundi", coordinates: [782.5, 461.17] }, //fixed
//     { name: "Cambodia", coordinates: [985.78, 411.77] }, //fixed
//     { name: "Cameroon", coordinates: [735.37, 432.78] }, //fixed
//     { name: "Canada", coordinates: [457.14, 260.73] }, //fixed
//     { name: "Guernsey", coordinates: [694.49, 294.8] }, //fixed
//     { name: "China", coordinates: [969.32, 341.93] }, //fixed
//     { name: "Costa Rica", coordinates: [471.9, 419.72] }, //fixed
//     { name: "Cyprus", coordinates: [787.61, 339.09] }, //fixed
//     { name: "Czechia", coordinates: [737.08, 292.53] }, //fixed
//     { name: "Denmark", coordinates: [721.75, 273.76] }, //fixed
//     { name: "Estonia", coordinates: [759.22, 265.84] }, //fixed
//     { name: "Falkland Islands", coordinates: [559.84, 615.05] },
//     { name: "Finland", coordinates: [757.27, 248.8] },
//     { name: "France", coordinates: [707.39, 304.17] },
//     { name: "Germany", coordinates: [726.1, 289.18] },
//     { name: "Ghana", coordinates: [698.38, 425.73] },
//     { name: "Cayman Islands", coordinates: [484.22, 388.99] },
//     { name: "Greece", coordinates: [762.3, 328.97] },
//     { name: "Hong Kong", coordinates: [1006.67, 379.87] },
//     { name: "Hungary", coordinates: [748.67, 301.22] },
//     { name: "Iceland", coordinates: [660.3, 248.46] },
//     { name: "India", coordinates: [920.64, 383.79] },
//     { name: "Indonesia", coordinates: [1024.7, 458.94] },
//     { name: "Ireland", coordinates: [681.76, 282.04] },
//     { name: "Israel", coordinates: [792.64, 350.89] },
//     { name: "Italy", coordinates: [732.74, 317.81] },
//     { name: "Jamaica", coordinates: [492.57, 393.45] },
//     { name: "Japan", coordinates: [1054.42, 340.09] },
//     { name: "Jordan", coordinates: [798.34, 351.44] },
//     { name: "Kazakhstan", coordinates: [863.05, 298.92] },
//     { name: "Lao People's Democratic Republic", coordinates: [981.77, 393.16] },
//     { name: "Lebanon", coordinates: [794.14, 343.15] },
//     { name: "Lithuania", coordinates: [756.56, 276.82] },
//     { name: "Luxembourg", coordinates: [715.88, 293] },
//     { name: "Malawi", coordinates: [794.29, 493.11] },
//     { name: "Malaysia", coordinates: [1000.81, 437.97] },
//     { name: "Malta", coordinates: [738.15, 336.55] },
//     { name: "Mauritius", coordinates: [855.94, 515.35] },
//     { name: "Mexico", coordinates: [428.95, 375.84] },
//     { name: "Mozambique", coordinates: [797.62, 510.32] },
//     { name: "Namibia", coordinates: [751.15, 523.98] },
//     { name: "Nepal", coordinates: [923.37, 360.73] },
//     { name: "Netherlands", coordinates: [713.66, 285.98] },
//     { name: "New Caledonia", coordinates: [1142.17, 517.37] },
//     { name: "New Zealand", coordinates: [709.49, 589.02] },
//     { name: "Nigeria", coordinates: [724.78, 422.2] },
//     { name: "Norway", coordinates: [738.56, 249.99] },
//     { name: "Pakistan", coordinates: [881.27, 354.29] },
//     { name: "Peru", coordinates: [496.59, 480.2] },
//     { name: "Philippines", coordinates: [1034.17, 409.86] },
//     { name: "Poland", coordinates: [746.69, 286.58] },
//     { name: "Portugal", coordinates: [653.73, 332] },
//     { name: "Republic of Congo", coordinates: [741.95, 453.09] },
//     { name: "Reunion", coordinates: [850.28, 518.1] },
//     { name: "Russia", coordinates: [704.64, 262.83] },
//     { name: "Rwanda", coordinates: [783.06, 457.14] },
//     { name: "United Kingdom", coordinates: [693.75, 276.25] },
//     { name: "Senegal", coordinates: [661.91, 404.96] },
//     { name: "Serbia", coordinates: [752.99, 310.43] },
//     { name: "Singapore", coordinates: [985.82, 446.7] },
//     { name: "Slovakia", coordinates: [748.85, 296.48] },
//     { name: "South Africa", coordinates: [765.47, 547.48] },
//     { name: "South Korea", coordinates: [1029.82, 336.67] },
//     { name: "Spain", coordinates: [682.66, 337.42] },
//     { name: "Qatar", coordinates: [837.31, 370.36] },
//     { name: "Eswatini", coordinates: [784.53, 535.37] },
//     { name: "Sweden", coordinates: [739.68, 256.75] },
//     { name: "Switzerland", coordinates: [721.3, 302.32] },
//     { name: "Taiwan", coordinates: [1021.05, 375.97] },
//     { name: "Tanzania", coordinates: [796.53, 471.17] },
//     { name: "Thailand", coordinates: [975.74, 409.61] },
//     { name: "Türkiye", coordinates: [790.92, 326.99] },
//     { name: "Uganda", coordinates: [789.66, 446.64] },
//     { name: "Ukraine", coordinates: [776.5, 297.54] },
//     { name: "United Arab Emirates", coordinates: [844.95, 373.6] },
//     { name: "United States", coordinates: [700.19, 310.86] },
//     { name: "Uruguay", coordinates: [556.2, 554.5] },
//     { name: "Uzbekistan", coordinates: [862.45, 319.42] },
//     { name: "Vietnam", coordinates: [986.83, 400.28] },
//     { name: "Zambia", coordinates: [776.87, 492.65] },
//     { name: "Zimbabwe", coordinates: [779.83, 511.44] },
// ];

const clickedCountries: any[] = [];

const countries = [
    {
        id: "AO",
        name: "Angola",
        x: 54.69,
        y: 66.08,
    },
    {
        id: "AU",
        name: "Australia",
        x: 87.01,
        y: 74.40,
    },
    {
        id: "AT",
        name: "Austria",
        x: 53.53,
        y: 22.94,
    },
    {
        id: "BH",
        name: "Bahrain",
        x: 63.48,
        y: 38.28,
    },
    {
        id: "BB",
        name: "Barbados",
        x: 33.33,
        y: 47.76,
    },
    {
        id: "BE",
        name: "Belgium",
        x: 50.98,
        y: 20.60,
    },
    {
        id: "BM",
        name: "Bermuda",
        x: 32.75,
        y: 34.22,
    },
    {
        id: "BW",
        name: "Botswana",
        x: 56.48,
        y: 72.74,
    },
    {
        id: "BR",
        name: "Brazil",
        "x": 36.57,
        "y": 64.92
    },
    {
        id: "VG",
        name: "British Virgin Islands",
        x: 32.17,
        y: 43.87,
    },
    {
        id: "BI",
        name: "Burundi",
        x: 58.16,
        y: 59.72,
    },
    {
        id: "KH",
        name: "Cambodia",
        x: 78.88,
        y: 48.42,
    },
    {
        id: "CM",
        name: "Cameroon",
        x: 53.35,
        y: 53.24,
    },
    {
        id: "CA",
        name: "Canada",
        x: 24.99,
        y: 13.84,
    },
    {
        id: "GG",
        name: "Guernsey",
        x: 49.18,
        y: 21.64,
    },
    {
        id: "CN",
        name: "China",
        x: 77.20,
        y: 32.43,
    },
    {
        id: "CR",
        name: "Costa Rica",
        x: 26.50,
        y: 50.23,
    },
    {
        id: "CY",
        name: "Cyprus",
        x: 58.68,
        y: 31.78,
    },
    {
        id: "CZ",
        name: "Czechia",
        x: 53.53,
        y: 21.16,
    },
    {
        id: "DK",
        name: "Denmark",
        x: 51.97,
        y: 16.86,
    },
    {
        id: "EE",
        name: "Estonia",
        x: 55.85,
        y: 15.14,
    },
    {
        id: "FK",
        name: "Falkland Islands",
        x: 35.47,
        y: 95.20,
    },
    {
        id: "FI",
        name: "Finland",
        x: 55.79,
        y: 12.54,
    },
    {
        id: "FR",
        name: "France",
        x: 50.46,
        y: 23.72,
    },
    {
        id: "DE",
        name: "Germany",
        x: 52.20,
        y: 20.47,
    },
    {
        id: "GH",
        name: "Ghana",
        x: 49.54,
        y: 51.53,
    },
    {
        id: "KY",
        name: "Cayman Islands",
        x: 27.55,
        y: 43.21,
    },
    {
        id: "GR",
        name: "Greece",
        x: 55.61,
        y: 28.79,
    },
    {
        id: "HK",
        name: "Hong Kong",
        x: 80.96,
        y: 41.20,
    },
    {
        id: "HU",
        name: "Hungary",
        x: 54.69,
        y: 23.27,
    },
    {
        id: "IS",
        name: "Iceland",
        x: 45.89,
        y: 11.18,
    },
    {
        id: "IN",
        name: "India",
        x: 71.35,
        y: 41.20,
    },
    {
        id: "ID",
        name: "Indonesia",
        x: 81.89,
        y: 57.83,
    },
    {
        id: "IE",
        name: "Ireland",
        x: 47.92,
        y: 18.98,
    },
    {
        id: "IL",
        name: "Israel",
        x: 59.20,
        y: 34.70,
    },
    {
        id: "IT",
        name: "Italy",
        x: 52.95,
        y: 26.12,
    },
    {
        id: "JM",
        name: "Jamaica",
        x: 28.65,
        y: 44.32,
    },
    {
        id: "JP",
        name: "Japan",
        x: 86.17,
        y: 30.93,
    },
    {
        id: "JO",
        name: "Jordan",
        x: 59.61,
        y: 35.09,
    },
    {
        "id": "US",
        "name": "United States",
        "x": 23.61,
        "y": 28.07
    },
    {
        "id": "MX",
        "name": "Mexico",
        "x": 21.93,
        "y": 39.97
    },
    {
        "id": "RU",
        "name": "Russia",
        "x": 74.1,
        "y": 13.01
    },
    {
        "id": "NO",
        "name": "Norway",
        "x": 52.66,
        "y": 14.17
    },
    {
        "id": "SE",
        "name": "Sweden",
        "x": 53.18,
        "y": 14.3
    },
    {
        "id": "GB",
        "name": "United Kingdom",
        "x": 49.54,
        "y": 17.94
    },
    {
        "id": "NL",
        "name": "Netherlands",
        "x": 51.16,
        "y": 19.89
    },
    {
        "id": "CH",
        "name": "Switzerland",
        "x": 51.79,
        "y": 23.4
    },
    {
        "id": "ES",
        "name": "Spain",
        "x": 48.61,
        "y": 28.2
    },
    {
        "id": "PT",
        "name": "Portugal",
        "x": 47.74,
        "y": 28.46
    },
    {
        "id": "SN",
        "name": "Senegal",
        "x": 45.83,
        "y": 46.4
    },
    {
        "id": "NG",
        "name": "Nigeria",
        "x": 51.97,
        "y": 51.6
    },
    {
        "id": "CG",
        "name": "Republic of Congo",
        "x": 54.34,
        "y": 57.05
    },
    {
        "id": "PE",
        "name": "Peru",
        "x": 28.82,
        "y": 64.79
    },
    {
        "id": "UY",
        "name": "Uruguay",
        "x": 34.95,
        "y": 80.97
    },
    {
        "id": "ZA",
        "name": "South Africa",
        "x": 56.71,
        "y": 77.91
    },
    {
        "id": "NA",
        "name": "Namibia",
        "x": 54.51,
        "y": 73.49
    },
    {
        "id": "ZW",
        "name": "Zimbabwe",
        "x": 57.81,
        "y": 70.57
    },
    {
        "id": "ZM",
        "name": "Zambia",
        "x": 57.29,
        "y": 68.36
    },
    {
        "id": "SZ",
        "name": "Eswatini",
        "x": 58.33,
        "y": 76.74
    },
    {
        "id": "MZ",
        "name": "Mozambique",
        "x": 59.2,
        "y": 71.03
    },
    {
        "id": "TZ",
        "name": "Tanzania",
        "x": 59.78,
        "y": 61.8
    },
    {
        "id": "MW",
        "name": "Malawi",
        "x": 59.26,
        "y": 65.63
    },
    {
        "id": "UG",
        "name": "Uganda",
        "x": 58.85,
        "y": 56.47
    },
    {
        "id": "RW",
        "name": "Rwanda",
        "x": 58.22,
        "y": 59
    },
    {
        "id": "AE",
        "name": "United Arab Emirates",
        "x": 64.76,
        "y": 39.77
    },
    {
        "id": "PK",
        "name": "Pakistan",
        "x": 67.36,
        "y": 37.82
    },
    {
        "id": "NP",
        "name": "Nepal",
        "x": 72.16,
        "y": 36.39
    },
    {
        "id": "TH",
        "name": "Thailand",
        "x": 78.59,
        "y": 44.84
    },
    {
        "id": "TW",
        "name": "Taiwan",
        "x": 82.64,
        "y": 40.42
    },
    {
        "id": "KR",
        "name": "South Korea",
        "x": 83.33,
        "y": 30.67
    },
    {
        "id": "LA",
        "name": "Lao PDR",
        "x": 78.59,
        "y": 42.76
    },
    {
        "id": "VN",
        "name": "Vietnam",
        "x": 79.92,
        "y": 48.09
    },
    {
        "id": "MY",
        "name": "Malaysia",
        "x": 78.36,
        "y": 54.72
    },
    {
        "id": "PH",
        "name": "Philippines",
        "x": 84.66,
        "y": 51.99
    },
    {
        "id": "NC",
        "name": "New Caledonia",
        "x": 95.2,
        "y": 73.17
    },
    {
        "id": "NZ",
        "name": "New Zealand",
        "x": 95.43,
        "y": 85.78
    },
    {
        "id": "KZ",
        "name": "Kazakhstan",
        "x": 66.84,
        "y": 23.79
    },
    {
        "id": "TR",
        "name": "Türkiye",
        "x": 59.66,
        "y": 28.46
    },
    {
        "id": "UZ",
        "name": "Uzbekistan",
        "x": 65.8,
        "y": 26.51
    },
    {
        "id": "QA",
        "name": "Qatar",
        "x": 63.77,
        "y": 39.12
    },
    {
        "id": "LB",
        "name": "Lebanon",
        "x": 59.32,
        "y": 32.75
    },
    {
        "id": "UA",
        "name": "Ukraine",
        "x": 57.52,
        "y": 20.41
    },
    {
        "id": "PL",
        "name": "Poland",
        "x": 54.8,
        "y": 19.76
    },
    {
        "id": "LT",
        "name": "Lithuania",
        "x": 55.56,
        "y": 17.42
    },
    {
        "id": "SK",
        "name": "Slovakia",
        "x": 54.69,
        "y": 21.97
    },
    {
        "id": "RS",
        "name": "Serbia",
        "x": 55.03,
        "y": 24.83
    },
    {
        "id": "LU",
        "name": "Luxembourg",
        "x": 51.39,
        "y": 21.32
    },
    {
        "id": "RE",
        "name": "Reunion",
        "x": 65.05,
        "y": 72.78
    },
    {
        "id": "MU",
        "name": "Mauritius",
        "x": 65.63,
        "y": 72.26
    },
    {
        "id": "MT",
        "name": "Malta",
        "x": 53.65,
        "y": 31.26
    },
    {
        "id": "SG",
        "name": "Singapore",
        "x": 78.82,
        "y": 56.6
    },
];



const countryNames: Record<string, string> = {
    MT: "Malta",
    SG: "Singapore",
};




export default function MapProto() {
    const [hoveredCountry, setHoveredCountry] =
        useState<string | null>(null);

    const hoverCount = useRef(0);

    const beginHover = (id: string) => {
        hoverCount.current++;
        setHoveredCountry(id);
    };

    const endHover = () => {
        hoverCount.current--;

        setTimeout(() => {
            if (hoverCount.current <= 0) {
                hoverCount.current = 0;
                setHoveredCountry(null);
            }
        }, 0);
    };

    const [remainingCountries, setRemainingCountries] =
        useState(
            new Set(Object.keys(countryNames))
        );

    useEffect(() => {
        document
            .querySelectorAll(".land")
            .forEach((country) => {
                const path =
                    country as SVGPathElement;

                path.classList.remove(
                    "needs-click"
                );

                if (
                    remainingCountries.has(
                        path.id
                    )
                ) {
                    path.classList.add(
                        "needs-click"
                    );
                }
            });
    }, [remainingCountries]);

    useEffect(() => {
        const availableCountries = new Set(
            countries.map((c) => c.id)
        );

        document
            .querySelectorAll(".land")
            .forEach((country) => {
                const path = country as SVGPathElement;

                if (
                    availableCountries.has(path.id)
                ) {
                    path.classList.add(
                        "interactive-country"
                    );
                } else {
                    path.classList.remove(
                        "interactive-country"
                    );
                }
            });
    }, []);
    useEffect(() => {
        const elements =
            document.querySelectorAll(".land");

        elements.forEach((country) => {
            const path = country as SVGPathElement;

            path.onmouseenter = () =>
                beginHover(path.id);

            path.onmouseleave = () =>
                endHover();
        });

        return () => {
            elements.forEach((country) => {
                const path = country as SVGPathElement;

                path.onmouseenter = null;
                path.onmouseleave = null;
            });
        };
    }, []);


    useEffect(() => {

        document
            .querySelectorAll(".land")
            .forEach((country) => {
                country.classList.remove("active-country");
                country.classList.remove("hover-country");
            });

        if (!hoveredCountry) return;

        const element = document.getElementById(hoveredCountry);

        if (!element) return;

        const isSupported = countries.some(
            (c) => c.id === hoveredCountry
        );

        element.classList.add(
            isSupported ? "active-country" : "hover-country"
        );
    }, [hoveredCountry]);

    const tooltipCountry = countries.find(
        (c) => c.id === hoveredCountry
    );
    return (
        <div className="">
            <div className="international-map-wrapper-test">
                <div className="svg-map-container-test"
                     >
                    <WorldMap className="world-map-svg" />

                    {countries.map((country) => (
                        <div
                            key={country.id}
                            className="map-marker"
                            onMouseEnter={() => beginHover(country.id)}
                            onMouseLeave={endHover}
                            style={{
                                left: `${country.x}%`,
                                top: `${country.y}%`,
                            }}
                        >
                            <svg
                                className="map-pin"
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 24 24"
                            >
                                <path
                                    d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 10.5A3.5 3.5 0 1 1 12 5.5a3.5 3.5 0 0 1 0 7z"
                                    fill="#8B6A3C"
                                />
                            </svg>

                            {hoveredCountry === country.id && (
                                <div className="map-tooltip">
                                    {country.name}
                                </div>
                            )}
                        </div>
                    ))}


                </div>
                <div className="map-locations-test">
                    {[...countries]
                        .sort((a, b) => a.name.localeCompare(b.name))
                        .map((country) => (
                            <div
                                key={country.id}
                                className="map-location"
                                onMouseEnter={() =>
                                    beginHover(country.id)
                                }
                                onMouseLeave={endHover}
                            >
                                {country.name}
                            </div>
                        ))}
                </div>
            </div>

        </div>
    );
}
